import type { FC, ReactNode } from "react"
import Box from "@mui/material/Box"

import { CELL_GAP } from "./helpers"

// One column of the grid. Every row holds one per visible span at `flex: 1 1 0`,
// so the columns line up on their own. Keep cells free of margins and widths:
// the gap between bars is padding inside the cell.
const GridCell: FC<{ children?: ReactNode; sx?: object }> = ({ children, sx }) => (
  <Box
    sx={{
      flex: "1 1 0",
      minWidth: 0,
      position: "relative",
      px: `${CELL_GAP / 2}px`,
      ...sx,
    }}
  >
    {children}
  </Box>
)

export default GridCell
